var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Php(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "150px",
    height: "150px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#38bdf8",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,12c-6.49219,0 -12.37891,1.35938 -16.72656,3.62891c-4.34766,2.26953 -7.27344,5.53906 -7.27344,9.37109c0,3.83203 2.92578,7.10156 7.27344,9.37109c4.34766,2.26953 10.23437,3.62891 16.72656,3.62891c6.49219,0 12.37891,-1.35937 16.72656,-3.62891c4.34766,-2.26953 7.27344,-5.53906 7.27344,-9.37109c0,-3.83203 -2.92578,-7.10156 -7.27344,-9.37109c-4.34766,-2.26953 -10.23437,-3.62891 -16.72656,-3.62891zM25,14c6.21094,0 11.82422,1.32422 15.80078,3.40234c3.97656,2.07422 6.19922,4.80078 6.19922,7.59766c0,2.79688 -2.22266,5.52344 -6.19922,7.59766c-3.97656,2.07813 -9.58984,3.40234 -15.80078,3.40234c-6.21094,0 -11.82422,-1.32422 -15.80078,-3.40234c-3.97656,-2.07422 -6.19922,-4.80078 -6.19922,-7.59766c0,-2.79687 2.22266,-5.52344 6.19922,-7.59766c3.97656,-2.07812 9.58984,-3.40234 15.80078,-3.40234zM22.50781,16l-2.50781,12h2.625l1.26563,-6h2.09766c0.66797,0 1.11328,0.10938 1.32031,0.33203c0.20313,0.22266 0.24609,0.64453 0.12891,1.25l-0.95703,4.41797h2.66406l1.03906,-4.77734c0.22266,-1.14453 0.05469,-1.98437 -0.5,-2.49609c-0.56641,-0.51953 -1.5625,-0.72656 -3.04687,-0.72656h-2.33984l0.83203,-4zM11,20l-2.02734,11h2.64453l0.52734,-3h1.64844c3.44531,0 5.32031,-0.79687 6.01953,-3.75391c0.60156,-2.54297 -0.9375,-4.24609 -3.48047,-4.24609zM32,20l-2.02734,11h2.64453l0.52734,-3h1.64844c3.44531,0 5.32031,-0.79687 6.01953,-3.75391c0.60156,-2.54297 -0.9375,-4.24609 -3.48047,-4.24609zM13.27344,22h2.05859c1.71094,0 2.07031,0.76953 1.98047,1.625c-0.23047,2.20703 -1.60547,2.375 -3.08203,2.375h-1.71484zM34.27344,22h2.05859c1.71094,0 2.07031,0.76953 1.98047,1.625c-0.23047,2.20703 -1.60547,2.375 -3.08203,2.375h-1.71484z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Php);
export default __webpack_public_path__ + "static/media/icons8-php.40614950c6d120d419c255b4a22d6a49.svg";
export { ForwardRef as ReactComponent };